import React, { Component } from 'react';
import createStyledComponent from '../utils/createStyledComponent.js';
import * as styles from './styles/index.js';
import { commonStyle, tooltipStyle } from './styles/common.js';
const ButtonWrapper = createStyledComponent(styles, 'button');
const TooltipWrapper = createStyledComponent(tooltipStyle);
const CommonWrapper = createStyledComponent(commonStyle);
class Button extends Component {
    constructor() {
        super(...arguments);
        this.onMouseUp = (e) => {
            e.currentTarget.blur();
        };
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.children !== this.props.children ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.mark !== this.props.mark ||
            nextProps.size !== this.props.size ||
            nextProps.primary !== this.props.primary ||
            nextProps.tooltipPosition !== this.props.tooltipPosition ||
            nextProps.title !== this.props.title);
    }
    render() {
        const button = (React.createElement(ButtonWrapper, { theme: this.props.theme, "aria-label": this.props.title, primary: this.props.primary, disabled: this.props.disabled, onMouseUp: this.onMouseUp, onClick: this.props.onClick, type: this.props.type }, this.props.children));
        const Wrapper = this.props.title ? TooltipWrapper : CommonWrapper;
        return (React.createElement(Wrapper, { theme: this.props.theme, tooltipTitle: this.props.title, tooltipPosition: this.props.tooltipPosition, size: this.props.size, mark: this.props.mark }, button));
    }
}
Button.defaultProps = {
    tooltipPosition: 'top',
};
export default Button;
